import { render, staticRenderFns } from "./LandPlace.vue?vue&type=template&id=3735e746&scoped=true"
import script from "./LandPlace.vue?vue&type=script&lang=js"
export * from "./LandPlace.vue?vue&type=script&lang=js"
import style0 from "./LandPlace.vue?vue&type=style&index=0&id=3735e746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3735e746",
  null
  
)

export default component.exports